<div class="modal-container"
    #component>
    <div class="bg_shadow"></div>
    <div class="modal">
        <div *ngIf="(title !== '' && title !== null && title !== undefined) || cross"
            class="modal-header">
            <div class="modal-status">
                <h2 class="font-sans text-2xl text-eggplant-100">{{ title }}</h2>
            </div>
            <div *ngIf="cross" class="modal-cross hover:cursor-pointer" (click)="close()">
                <fun-icon [name]="'x-close'" [style]="'w-32 h-32 stroke-gray-40 stroke-2'"></fun-icon>
            </div>
            <div class="line"></div>
        </div>
        <div>
            <div #componentPlaceholder></div>
        </div>
    </div>
</div>